import { DoubleHeader } from '@rsa-digital/evo-shared-components/components/Header';
import {
  CardSectionContainer,
  CardSectionCta,
  CardSectionHeading,
} from '@rsa-digital/evo-shared-components/components/Header/DoubleHeader/CardSection/styles';
import { Section } from '@rsa-digital/evo-shared-components/components/Header/NavDesktop/PrimaryNavDesktop/Menus/styles';
import colors from '@rsa-digital/evo-shared-components/helpers/colors';
import mediaQuery from '@rsa-digital/evo-shared-components/helpers/mediaQuery';
import { themeSpecificColors } from '@rsa-digital/evo-shared-components/theme/RSA/colors';
import styled from 'styled-components';

export const StyledDoubleHeader = styled(DoubleHeader)`
  && {
    ${Section}:only-child:has(${CardSectionContainer}) {
      width: auto;
    }
  }

  ${CardSectionContainer} {
    background-color: transparent;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  ${CardSectionHeading} {
    font-weight: 500;
    line-height: 2rem;
    color: ${themeSpecificColors.core04_40};
  }

  ${CardSectionCta} {
    width: 100%;
    ${mediaQuery.tabletPortrait`
      width: auto;
    `}

    &:hover {
      box-shadow: inset 0 0 0 2px ${colors.neutral08};
    }
  }
`;
